import { Signal } from '@angular/core';
import { Uuid } from '@softline/core';
import { FieldFilter } from '../../../../types/filter';
import { FilterConfig, FilterItemConfig } from '../../../../types/filter-config';
import { FilterOperator } from '../../../../types/filter-operators';

/** Mutation surface the recursive filter nodes talk to (provided by the custom tab). */
export abstract class FilterTreeEditor {
  abstract readonly config: Signal<FilterConfig<any>>;
  abstract addCondition(groupUuid: Uuid): void;
  abstract addGroup(groupUuid: Uuid): void;
  abstract remove(uuid: Uuid): void;
  abstract setGroupOperator(uuid: Uuid, operator: 'AND' | 'OR'): void;
  abstract setConditionField(uuid: Uuid, field: string): void;
  abstract setConditionOperator(uuid: Uuid, operator: FilterOperator): void;
  abstract setConditionValue(uuid: Uuid, value: unknown): void;
  abstract editValues(node: FieldFilter<any>): void;
  abstract getItemConfig(field: string): FilterItemConfig<any> | null;
}
